export const LogoImgContainer = `
    width: 133px;
    height: 33px;
`;
